module.exports = __webpack_public_path__ + "static/media/light_lumen_icon.776ad604.svg";